import { Box, Button, Flex, Link } from "@chakra-ui/react";
import { LuExternalLink } from "react-icons/lu";

export const Home = () => {
  return (
    <Box pt={"100px"}>
      <Flex justifyContent={"center"} align={"center"}>
        <Button asChild>
          <a href="/pokemons">Get Started</a>
        </Button>
        <Link href="https://github.com/You-saku">
          GitHub <LuExternalLink />
        </Link>
      </Flex>
    </Box>
  );
};
